var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Refresh_Icon",
    "data-name": "Refresh Icon",
    transform: "translate(-1849 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5788",
    "data-name": "Rectangle 5788",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(1849 80)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Refresh",
    d: "M19.355,6.644a9,9,0,1,0,2.34,8.606h-2.34A6.747,6.747,0,1,1,13,6.25a6.654,6.654,0,0,1,4.748,2l-3.623,3.623H22V4Z",
    transform: "translate(1860.99 92)",
    fill: "#474b4f",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon_refresh.5d8b7f84d55b3e5d5e54ef6b7f184ac4.svg";
export { ForwardRef as ReactComponent };